import { Component, OnInit } from '@angular/core';
import { JsonPipe } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { trigger, transition, style, animate } from '@angular/animations';
import { Store } from '@ngrx/store';
import { listingsFeature } from '../../store/listings.store';
import { filter, lastValueFrom, take } from 'rxjs';
import { ListingPublic, ListingVariationPublic } from '../../../../globalTypes/listings.types';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { accountFeature } from '../../store/account.store';
import { LocationPublic } from '../../../../globalTypes/account.types';
import { getListing } from '@dataconnect/account';
import { Logger } from '../../helper/logger';
import { DisplayListingsComponent } from "./display-listing.component";
const log = new Logger("DisplayListingsComponent");

@Component({
  selector: 'msh-display-listings-page',
  standalone: true,
  imports: [MatButtonModule, DisplayListingsComponent, RouterLink],
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('300ms ease-in', style({ opacity: 1 }))
      ]),
      transition(':leave', [
        animate('300ms ease-out', style({ opacity: 0 }))
      ])
    ]),
    trigger('scaleIn', [
      transition(':enter', [
        style({ transform: 'scale(0.9)', opacity: 0 }),
        animate('200ms ease-out', style({ transform: 'scale(1)', opacity: 1 }))
      ])
    ])
  ],
  template: `
<div class=" max-w-7xl mx-auto p-4">
  <div class=" cursor-pointer text-orange-400 text-xs ml-4" [routerLink]="['/listing','search']">< back to search</div>
  @if(listingId){
    <msh-display-listings [listingId]="listingId" ></msh-display-listings>
  }
</div>

  `,
  styles: []
})
export class DisplayListingsPageComponent implements OnInit {

  listing!: ListingPublic;
  listingId!: string;
  locations: {[locationId: string]: LocationPublic} = {}

  constructor(
    private store: Store,
    private route: ActivatedRoute,
  ){
    if(this.route.snapshot.params['listingId']) this.listingId = this.route.snapshot.params['listingId']
  }

  async ngOnInit(): Promise<void> {
    this.store.select(listingsFeature.selectListing).pipe(take(1)).subscribe(async listing=>{
      if(listing){
        this.listing = listing as ListingPublic
      }else{
        if(!this.listingId) throw Error('No listingId available')
        const listingRef = await getListing({listingId: this.listingId});
        if(listingRef.data.listings.length > 0){
          this.listing = listingRef.data.listings[0] as ListingPublic;
          console.log({msg:'got it here ', listingRef})
        }
      }
    })
    this.locations = await lastValueFrom(this.store.select(accountFeature.selectLocations).pipe(take(1)))
  }

}
